import React from 'react';
import PropTypes from 'prop-types';
// import Icon, {ICON_COLOR, ICON_KIND} from '@gerenciatd/next.components.icon';
import { convertToKebabCase } from '@/utils/htmlUtils';
import FlashFatalError from '@/components/FlashFatalError/FlashFatalError';
import Shape, { ShapeColor, ShapeSize, ShapeTypes } from '@/components/Shape/Shape';
import styles from './styles';
// import Button, { BUTTON_COLOR } from '@gerenciatd/next.components.button';
/**
 * Stateless component to draw a ErrorScreen.
 * @param {string} errorTitle error title.
 * @param {string} errorSubtitle Determine the errorSubtitle of the error.
 * @param {string} errorMessage Determine the message of the error.
 * @param {string} errorImage Determine the image of the error.
 * @param {string} errorAlt Detrmine the alt of image.
 * @param {string} errorLabelButton label of the button,emty label button not visible.
 * @returns {JSX} Component Period JSX.
 */

const ErrorScreen = ({
  wrapperClass,
  onClick,
  errorTitle,
  errorSubtitle,
  errorMessage,
  errorImage,
  errorLabelButton,
  errorAlt,
  errorLink,
  fatalError,
  currentLocationWebviewCatalogue,
  svgIcon,
}) => {
  const link = document.createElement("link");
  link.href = "https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap";
  link.rel = "stylesheet";
  document.head.appendChild(link);

  const buttonVisible = errorLabelButton !== '';
  const id = convertToKebabCase(errorTitle);

  if (currentLocationWebviewCatalogue) {
    return (
      <div className={`errorScreen ${wrapperClass}`}>
        <div className="errorImage">
          {fatalError && (
            <div className="fatalError">
              <FlashFatalError />
            </div>
          )}
          {!fatalError && errorImage && (
            <img
              className="imageError"
              src={errorImage}
              align="middle"
              alt={errorAlt}
              height="auto"
              width="160"
            />
          )}

        </div>
        <div className="errorTitle">{errorTitle}</div>
        {errorSubtitle && <div className="errorSubtitle">{errorSubtitle}</div>}
        {errorMessage && <div className="errorMessage">{errorMessage}</div>}
        <style jsx>{styles}</style>
      </div>
    )
  }

  return (
    <div className={`errorScreen ${wrapperClass}`}>
      {svgIcon && (
        <Shape
          color={ShapeColor.GREY}
          type={ShapeTypes.CIRCLE}
          size={ShapeSize.XL}
        >
          {/* <Icon id={svgIcon} kind={ICON_KIND.LIGHT} color={ICON_COLOR.BLUE} size={48} /> */}
        </Shape>
      )}
      <div className="errorTitle">{errorTitle}</div>
      <div className="errorImage">
        {fatalError && (
          <div className="fatalError">
            <FlashFatalError />
          </div>
        )}
        {!fatalError && errorImage && (
        <img
          className="imageError"
          src={errorImage}
          align="middle"
          alt={errorAlt}
          height="auto"
          width="160"
        />
        )}
      </div>
      {errorSubtitle && <div className="errorSubtitle">{errorSubtitle}</div>}
      {errorMessage && <div className="errorMessage">{errorMessage}</div>}
      {/* {buttonVisible &&
      <Button
        id={id}
        onClick={onClick}
        text={errorLabelButton}
        backgroundColor={BUTTON_COLOR.BLUE}
        isReactLink
        href={errorLink}
      />
      } */}
       <style jsx>{styles}</style>
    </div>
  );
}

ErrorScreen.propTypes = {
  wrapperClass: PropTypes.string,
  fatalError: PropTypes.bool,
  errorTitle: PropTypes.string.isRequired,
  errorSubtitle: PropTypes.string,
  errorMessage: PropTypes.string,
  errorImage: PropTypes.func.isRequired,
  errorLabelButton: PropTypes.string,
  errorAlt: PropTypes.string.isRequired,
  errorLink: PropTypes.string,
  onClick: PropTypes.func,
};
ErrorScreen.defaultProps = {
  wrapperClass: '',
  errorLabelButton: '',
  errorMessage: null,
  errorSubtitle: '',
  errorLink: '',
  fatalError: false,
  onClick: () => {},
}


export default ErrorScreen;
